module.exports = __webpack_public_path__ + "img/img2.c9580271.jpg";